import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=810c3e46"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports